const state = {
  count: 0
}

const getters = {
  isLoading: (state) => {
    return state.count > 0
  }
}

const actions = {
  beginLoading ({ commit }) {
    commit('countUp')
  },
  endLoading ({ commit }) {
    commit('countDown')
  },
  resetLoading ({ commit }) {
    commit('reset')
  }
}

const mutations = {
  countUp (state) {
    state.count = state.count + 1
  },
  countDown (state) {
    state.count = state.count - 1
  },
  reset (state) {
    state.count = 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
